const CHINA_DOMAIN = 'jabra.cn';
// China: jabra.cn, public-*-cn.gnajabra.com
const CHINA_PUBLIC_ENV_MATCHER = /public-(dev|ci|qa|uat)-cn\.gnajabra\.com/;

export const isBlueParrottHostname = (hostname: string, queryString?: string): boolean => {
  if (queryString?.includes('sc_site=njord-blueparrott')) {
    return true;
  }

  return (
    hostname.includes('blueparrott.com') || hostname === 'fe.blueparrott.njord-store.localhost.tech'
  );
};

export const isJabraHostname = (hostname: string, queryString?: string): boolean => {
  if (queryString?.includes('sc_site=njord-store')) {
    return true;
  }

  return (
    hostname.includes('jabra.com') ||
    hostname === 'fe.jabra.njord-store.localhost.tech' ||
    hostname === 'localhost' // localhost defaults to Jabra
  );
};

export const isChinaHostname = (hostname: string): boolean =>
  hostname.includes(CHINA_DOMAIN) || CHINA_PUBLIC_ENV_MATCHER.test(hostname);
